import { __decorate, __param, __metadata, __awaiter } from 'tslib';
import { Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpHeaders, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { DOCUMENT, CommonModule } from '@angular/common';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { BehaviorSubject } from 'rxjs';
import { Platform } from '@ionic/angular';
import CryptoJS from 'crypto-js';
import { jwtDecode } from 'jwt-decode';
import { KeycloakService } from 'keycloak-angular';

let ConfigOauthService = class ConfigOauthService {
    constructor(param) {
        this.uri = param.config.apiUri;
        this.keyForm = param.config.keyForm;
        this.authTokenKey = param.config.authTokenKey;
        this.typeUpload = param.config.typeUpload;
        this.keyAccount = param.config.keyAccount;
        this.realm = param.config.keycloakConfig.realm;
        this.saltKey = param.config.saltKey;
    }
    getUri() {
        return this.uri;
    }
    getKeyForm() {
        return this.keyForm;
    }
    getAuthTokenKey() {
        return this.authTokenKey;
    }
    getTypeUpload() {
        return this.typeUpload;
    }
    getKeyAccount() {
        return this.keyAccount;
    }
    getRealm() {
        return this.realm;
    }
    getSaltKey() {
        return this.saltKey;
    }
};
ConfigOauthService = __decorate([
    Injectable(),
    __param(0, Inject(APP_PARAMETER)),
    __metadata("design:paramtypes", [Object])
], ConfigOauthService);

let CryptoService = class CryptoService {
    // @dynamic
    cryptIt(keypass, data) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                let dataCrypt = CryptoJS.AES.encrypt(data, keypass).toString();
                dataCrypt = dataCrypt.replace(/\//g, '_B_').replace(/=/g, '_C_');
                resolve(dataCrypt);
            }
            catch (err) {
                console.error('houve um erro ao tentar criptografar os dados:: ' + err);
                reject('houve um erro ao tentar criptografar os dados');
            }
        }));
    }
    // @dynamic
    decryptIt(keypass, cypher) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                cypher = cypher.replace(/_B_/g, '/').replace(/_C_/g, '=').replace(/"/g, '');
                // console.log(`decryptIt:: cypher ${cypher}`);
                const byte = CryptoJS.AES.decrypt(cypher, keypass);
                // console.log(`decryptIt:: byte ${byte.toString()}`);
                resolve(byte.toString(CryptoJS.enc.Utf8));
            }
            catch (err) {
                console.error('houve um erro ao tentar descriptografar os dados:: ' + err);
                reject('houve um erro ao tentar criptografar os dados');
            }
        }));
    }
};
CryptoService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CryptoService_Factory() { return new CryptoService(); }, token: CryptoService, providedIn: "root" });
CryptoService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], CryptoService);

const moment = require('moment');
moment();
let StorageService = class StorageService {
    constructor(storage, platform, cryptoService, keycloakService) {
        this.storage = storage;
        this.platform = platform;
        this.cryptoService = cryptoService;
        this.keycloakService = keycloakService;
        this.tokenCurrent$ = new BehaviorSubject({});
    }
    set(key, value, expired = false, dateExpire) {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('adicionando no storage key: ' + key + ' value: ' + value);
            if (expired) {
                const keyPass = this.keyPass(yield this.getToken());
                this.setWithExpired(key, value, dateExpire, keyPass).then(res => {
                    return res;
                }).catch(error => {
                    console.error('Ocorreu erro ao tentar registrar novo token com data de expiração', error);
                });
            }
            else {
                return this.storage.set(key, value).then(res => {
                    // console.log('adicionando com sucesso');
                    return res;
                }).catch(error => {
                    console.error('Ocorreu erro ao tentar registrar novo token', error);
                });
            }
        });
    }
    getToken() {
        return this.keycloakService.getToken();
    }
    isPlatformMobile() {
        return this.platform.is('android') || this.platform.is('ios') || this.platform.is('cordova');
    }
    get(keyAuth, expired = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let dataRestored;
            // console.log('buscando no storage key: ' + key);
            if (!this.isPlatformMobile()) {
                // console.log('buscando no storage key - forEach: ' + key);
                dataRestored = this.storage.forEach((value, key, iterationNumber) => {
                    if (key.indexOf(keyAuth) > -1) {
                        return this.storage.get(keyAuth).then(res => {
                            // console.log('localizado  com sucesso: ' + res);
                            return res;
                        });
                    }
                });
            }
            else {
                dataRestored = this.storage.get(keyAuth).then(res => {
                    // console.log('localizado  com sucesso: ' + res);
                    return res;
                });
            }
            if (expired && (yield dataRestored)) {
                const keyPass = this.keyPass(yield this.getToken());
                // console.log('StorageService::dataRestored: ', keyAuth, dataRestored, isExist, keyPass);
                return this.validExpired(keyAuth, yield dataRestored, keyPass);
            }
            else {
                return dataRestored;
            }
        });
    }
    remove(key) {
        // console.log('removendo do storage key: ' + key);
        return this.storage.remove(key).then(res => {
            // console.log('removido  com sucesso: ' + res);
            return res;
        });
    }
    setWithExpired(key, value, dateExpire, keyPass) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!dateExpire) {
                console.error('Não é permitido inserir registro sem data de expiração');
                throw new Error('Não é permitido inserir registro sem data de expiração');
            }
            if (!keyPass) {
                console.error('Não é permitido inserir registro sem chave');
                throw new Error('Não é permitido inserir registro sem chave');
            }
            if (moment.isDate(dateExpire)) {
                console.error('Data de expiração não é valida', dateExpire);
                throw new Error('Data de expiração não é valida');
            }
            if (!value) {
                console.error('Não é permitido inserir registro vázio');
                throw new Error('Não é permitido inserir registro vázio');
            }
            // console.log('Iniciando o registro de storage criptografado: ', key, value, dateExpire, keyPass);
            const valueCrypt = yield this.cryptData(key, value, dateExpire, keyPass);
            this.storage.set(key, valueCrypt);
        });
    }
    validExpired(key, expired, keyPass) {
        return __awaiter(this, void 0, void 0, function* () {
            // console.log('validExpired::', key, expired);
            if (expired) {
                const decryptData = yield this.decryptData(expired, keyPass);
                // console.log('validExpired::decryptData::', decryptData);
                if (decryptData) {
                    // console.log(`Validaçao moment:: dateFinished::${moment(decryptData.value.dateFinished)} - Data Atual: ${( moment(new Date()))}`, moment(decryptData.value.dateFinished).isAfter( moment(new Date())));
                    if (moment(decryptData.value.dateFinished).isAfter(moment(new Date()))) {
                        return decryptData.value.data;
                    }
                    else {
                        // console.log('Registro Expirado');
                        this.remove(key);
                        return null;
                    }
                }
                // console.log('validExpired::decryptData:: Não conseguiu comparar o objeto', decryptData);
            }
            console.error('validExpired:: Tipo invalido para validação');
            return null;
        });
    }
    cryptData(key, value, dateExpire, keyPass) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('cryptData::cryptData::', key, value, dateExpire);
            // const device: DeviceInfoCustom = await this.get(StorageKeys.DEVICE_TOKENS);
            const newData = new DataStorageExpired(key, { data: value, dateCreated: moment(new Date()).toISOString(), dateFinished: dateExpire });
            console.log('cryptData::cryptData::newData::1', newData, keyPass);
            console.log('cryptData::cryptData::newData::2', newData, keyPass, JSON.stringify(newData));
            return this.cryptoService.cryptIt(keyPass, JSON.stringify(newData));
        });
    }
    decryptData(value, keyPass) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // const device: DeviceInfoCustom = await this.get(StorageKeys.DEVICE_TOKENS);
                console.log('decryptData::keyPass::', keyPass);
                return this.cryptoService.decryptIt(keyPass, value).then(res => {
                    console.log('decryptData::result::', res);
                    return JSON.parse(res);
                });
                return JSON.parse(value);
            }
            catch (err) {
                console.error('Não foi possível decriptografar os dados ', err);
                return null;
            }
        });
    }
    decodeJWT(token) {
        return jwtDecode(token);
    }
    keyPass(token) {
        const jwtDecode = this.decodeJWT(token);
        if (jwtDecode.sub) {
            return jwtDecode.sub;
        }
        throw new Error('Não foi possível localizar a chave');
    }
};
StorageService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(ɵɵinject(Storage), ɵɵinject(Platform), ɵɵinject(CryptoService), ɵɵinject(KeycloakService)); }, token: StorageService, providedIn: "root" });
StorageService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [Storage,
        Platform,
        CryptoService,
        KeycloakService])
], StorageService);
class DataStorageExpired {
    constructor(key, value) {
        this.key = key;
        this.value = value;
    }
}
class DataDetailStorage {
    constructor(data, dateCreated, dateFinished) {
        this.dateCreated = dateCreated;
        this.dateFinished = dateFinished;
        this.data = data;
    }
}

let ApiService = class ApiService {
    constructor(http, storageService, configService, document) {
        this.http = http;
        this.storageService = storageService;
        this.configService = configService;
        this.document = document;
        this.uri = this.configService.getUri();
        this.authTokenKey = this.configService.getAuthTokenKey();
    }
    prepareHttpHeaders(uuidAccountPayment, extras) {
        //  console.log('prepareHttpHeaders::zero::', uuidAccountPayment, extras);
        const httpOptions = {
            headers: new HttpHeaders({
                'X-Request-UAC': uuidAccountPayment ? uuidAccountPayment : '',
            }),
        };
        //   console.log('prepareHttpHeaders::primeiro::', httpOptions);
        if (extras) {
            for (const extra of extras) {
                httpOptions.headers = httpOptions.headers.append(extra.name, extra.value);
            }
        }
        //  console.log('prepareHttpHeaders::segundo::', httpOptions);
        return httpOptions;
    }
    get(path, extras) {
        const httpOptions = this.prepareHttpHeaders(null, extras);
        return this.http.get(this.uri + path, httpOptions);
    }
    getBlob(path) {
        // this.storageService.loadToken();
        return this.http.get(this.uri + path, {
            headers: new HttpHeaders({
            // 'X-Realm': this.configService.getRealm()
            }),
            responseType: 'blob',
        });
    }
    postBlob(path, dateReport) {
        // this.storageService.loadToken();
        return this.http.post(this.uri + path, dateReport, {
            headers: new HttpHeaders({
            // 'X-Realm': this.configService.getRealm()
            }),
            responseType: 'blob',
        });
    }
    put(path, body, uuidAccountPayment, extras) {
        const httpOptions = this.prepareHttpHeaders(uuidAccountPayment, extras);
        return this.http.put(this.uri + path, body, httpOptions);
    }
    patch(path, body, uuidAccountPayment, extras) {
        const httpOptions = this.prepareHttpHeaders(uuidAccountPayment, extras);
        return this.http.patch(this.uri + path, body, httpOptions);
    }
    post(path, body, uuidAccountPayment, extras) {
        const httpOptions = this.prepareHttpHeaders(uuidAccountPayment, extras);
        const uri = this.uri + path;
        return this.http.post(uri, body, httpOptions);
    }
    delete(path, uuidAccountPayment, extras) {
        const httpOptions = this.prepareHttpHeaders(uuidAccountPayment, extras);
        // console.log('delete::httpOptions::', httpOptions);
        return this.http.delete(this.uri + path, httpOptions);
    }
    getTypeAccount(uuidAccountPayment) {
        const uri = `/spe-view-n-account/v1/account-payment-type/${uuidAccountPayment}`;
        return this.get(uri);
    }
};
ApiService = __decorate([
    Injectable(),
    __param(3, Inject(DOCUMENT)),
    __metadata("design:paramtypes", [HttpClient,
        StorageService,
        ConfigOauthService, Object])
], ApiService);
class ExtraHeader {
}

var UiBsOauthModule_1;
let UiBsOauthModule = UiBsOauthModule_1 = class UiBsOauthModule {
    constructor(parentModule) {
        //.....
    }
    static forRoot(config) {
        return {
            ngModule: UiBsOauthModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsOauthModule = UiBsOauthModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            CommonModule,
            HttpClientModule,
            IonicStorageModule.forRoot()
        ],
        providers: [
            ApiService,
            ConfigOauthService
        ]
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsOauthModule])
], UiBsOauthModule);

class ExtraAttribute {
}
class UserProfileBase {
    constructor() {
        this.listAccounts = [];
    }
    isRoleMenu(role) {
        if (this.rolesMenu && this.rolesMenu.length > 0) {
            const existsRole = this.rolesMenu.filter(r => r == role);
            return existsRole.length > 0;
        }
        return false;
    }
}
class DeviceInfoBase {
}

class ResultStatusLiveness {
    constructor(status, valid) {
        this.status = status;
        this.valid = valid;
    }
}
var StatusLivenessEnum;
(function (StatusLivenessEnum) {
    StatusLivenessEnum["FLOW_DISABLED"] = "FLOW_DISABLED";
    StatusLivenessEnum["PENDENT"] = "PENDENT";
    StatusLivenessEnum["APPROVED"] = "APPROVED";
    StatusLivenessEnum["APPROVED_MANUAL"] = "APPROVED_MANUAL";
    StatusLivenessEnum["IN_AUTOMATIC_ANALYSIS"] = "IN_AUTOMATIC_ANALYSIS";
    StatusLivenessEnum["IN_MANUAL_ANALYSIS"] = "IN_MANUAL_ANALYSIS";
    StatusLivenessEnum["REPROVED"] = "REPROVED";
    StatusLivenessEnum["REVALIDATE"] = "REVALIDATE";
})(StatusLivenessEnum || (StatusLivenessEnum = {}));

class ResultTransactionKey {
    constructor(status, valid) {
        this.status = status;
        this.valid = valid;
    }
}
var TransactionKeyEnum;
(function (TransactionKeyEnum) {
    TransactionKeyEnum["NO_CONFIGURED"] = "NO_CONFIGURED";
    TransactionKeyEnum["CONFIGURED"] = "CONFIGURED";
    TransactionKeyEnum["RECONFIGURED"] = "RECONFIGURED";
    TransactionKeyEnum["FLOW_DISABLED"] = "FLOW_DISABLED";
})(TransactionKeyEnum || (TransactionKeyEnum = {}));

var StorageKeys;
(function (StorageKeys) {
    StorageKeys["OAUTH_TOKENS"] = "267e86b5-f372-11ea-b552-42642db3fedc";
})(StorageKeys || (StorageKeys = {}));

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
const SPE_N_ACCOUNTS = '/spe-n-accounts';
let AuthUtilBase = class AuthUtilBase {
    constructor(platform, apiService, cryptoService) {
        this.platform = platform;
        this.apiService = apiService;
        this.cryptoService = cryptoService;
    }
    getAllPlatformInfo() {
        return this.platform.platforms();
    }
    isPlatformMobile() {
        return this.platform.is('android') || this.platform.is('ios') || this.platform.is('cordova');
    }
    isIos() {
        return this.platform.is('ios');
    }
    prepareRedirectUri(keycloakConfig) {
        if (this.isPlatformMobile()) {
            return keycloakConfig.redirectUri;
        }
        else {
            return 'http://localhost:8100/app/dashboard';
        }
    }
    prepareRedirectUriDeepLinks(keycloakConfig) {
        if (this.isPlatformMobile()) {
            return keycloakConfig.redirectUri.replace('dashboard', '');
        }
        else {
            return 'http://localhost:8100/';
        }
    }
    prepareRedirectLogoutUri(keycloakConfig) {
        if (this.isPlatformMobile()) {
            return keycloakConfig.redirectLogoutUri;
        }
        else {
            return 'http://localhost:8100/';
        }
    }
    setUuidAccount(uuid, uuidWl) {
        localStorage.setItem('uuid_account_' + uuidWl, String(uuid));
    }
    getAccounts() {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/access/accounts`;
        return this.apiService.get(uri);
    }
    changeAccount(uuidUserAccount) {
        const uri = `${SPE_N_ACCOUNTS}/v1/access/change`;
        return this.apiService.put(uri, null, null, [{ name: 'X-User-Account-ID', value: uuidUserAccount }]);
    }
    prepareUserProfile(keycloakProfile) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let userProfile = new UserProfileBase();
                const userDetails = keycloakProfile;
                const uuidAccount = this.cleanAttribute(this.searchAttribute(userDetails, 'uuidAccount'));
                const accounts = this.getAccounts();
                yield accounts.toPromise().then((a) => {
                    for (const ac of a) {
                        if (!uuidAccount) {
                            this.changeAccount(ac.userId);
                        }
                        if (!uuidAccount || uuidAccount === ac.uuidAccount) {
                            userProfile.email = userDetails.email;
                            userProfile.isEC = false;
                            userProfile.uuidWhiteLabel = ac.uuidWl;
                            userProfile.uuidAccount = uuidAccount;
                            userProfile.nameComplete = ac.accountName;
                            userProfile.nameFirst = ac.accountName.split(' ')[0];
                            userProfile.nameInitials = ac.nameInitials;
                            userProfile.codeBank = ac.codeBank;
                            userProfile.nameBank = ac.nameBank;
                            userProfile.agencyBank = ac.agencyBank;
                            userProfile.numberAccountBank = ac.numberAccountBank;
                            userProfile.userEmail = ac.userEmail;
                            userProfile.userDocument = ac.userDocument;
                            userProfile.userName = ac.userName;
                            userProfile.accountType = ac.accountType;
                            userProfile.extraAttributes = this.preparerExtraAttribute(userDetails);
                            userProfile.listAccounts.push(ac);
                        }
                        else {
                            userProfile.listAccounts.push(ac);
                        }
                    }
                });
                return new Promise((resolve, reject) => {
                    resolve(userProfile);
                });
                // return userProfile;
            }
            catch (e) {
                console.error('Failed to load user details', e);
            }
        });
    }
    captureValue(value) {
        if (value && typeof value === 'object' && value.constructor === Array) {
            return value[0];
        }
        else {
            return value;
        }
    }
    preparerExtraAttribute(keycloakProfile) {
        let extras = new Array();
        if (keycloakProfile.attributes) {
            const keyNames = Object.keys(keycloakProfile.attributes);
            for (const attribute of keyNames) {
                if (attribute !== 'uuidAccount' &&
                    attribute !== 'uuidWhiteLabel' &&
                    attribute !== 'nameInitials' &&
                    attribute !== 'codeBank' &&
                    attribute !== 'nameBank' &&
                    attribute !== 'agencyBank' &&
                    attribute !== 'numberAccountBank' &&
                    attribute !== 'isEC' &&
                    attribute !== 'uuidWl' &&
                    attribute !== 'uuidAccount') {
                    extras.push({ key: attribute, value: this.captureValue(keycloakProfile.attributes[attribute]) });
                }
            }
            return extras;
        }
        return extras;
    }
    searchAttribute(keycloakProfile, attributeSearch) {
        if (keycloakProfile.attributes) {
            const keyNames = Object.keys(keycloakProfile.attributes);
            for (const attribute of keyNames) {
                if (attribute === attributeSearch) {
                    return this.captureValue(keycloakProfile.attributes[attribute]);
                }
            }
        }
        return null;
    }
    cleanAttribute(attribute) {
        if (attribute) {
            // @ts-ignore
            return (attribute + '').replace('"', '').replace('"', '');
        }
        return attribute;
    }
    createOptionInBrowser() {
        let OPTIONS = {};
        if (this.isIos()) {
            // console.log('OPTIONS IOS');
            OPTIONS = {
                toolbar: 'no', location: 'no', clearsessioncache: 'yes', clearcache: 'yes',
                hidenavigationbuttons: 'yes', toolbartranslucent: 'no',
                toolbarposition: 'top', hidden: 'no',
                usewkwebview: 'yes'
            };
        }
        else {
            // console.log('OPTIONS ANDROID');
            OPTIONS = {
                toolbar: 'no', location: 'no', fullscreen: 'yes',
                zoom: 'no', clearsessioncache: 'yes', clearcache: 'yes',
                footer: 'no', hidenavigationbuttons: 'yes', hideurlbar: 'yes',
                hidden: 'no', usewkwebview: 'yes'
            };
        }
        return OPTIONS;
    }
    isValidLiveness(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const jwtDecode = this.decodeJWT(token);
            if (jwtDecode.lvs) {
                const statusIDUnico = yield this.cryptoService.decryptIt(this.keyPass(token), jwtDecode.lvs);
                return new ResultStatusLiveness(StatusLivenessEnum[statusIDUnico], (statusIDUnico === 'APPROVED' || statusIDUnico === 'APPROVED_MANUAL' || statusIDUnico === 'FLOW_DISABLED'));
            }
            else {
                return new ResultStatusLiveness(StatusLivenessEnum.PENDENT, false);
            }
        });
    }
    isValidTransactionKey(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const jwtDecode = this.decodeJWT(token);
            if (jwtDecode.tnk) {
                const status = yield this.cryptoService.decryptIt(this.keyPass(token), jwtDecode.tnk);
                return new ResultTransactionKey(TransactionKeyEnum[status], (status === 'CONFIGURED' || status === 'FLOW_DISABLED'));
            }
            else {
                return new ResultTransactionKey(TransactionKeyEnum.NO_CONFIGURED, false);
            }
        });
    }
    decodeJWT(token) {
        return jwtDecode(token);
    }
    keyPass(token) {
        const jwtDecode = this.decodeJWT(token);
        if (jwtDecode.sub) {
            return jwtDecode.sub;
        }
        throw new Error('Não foi possível localizar a chave');
    }
};
AuthUtilBase.ngInjectableDef = ɵɵdefineInjectable({ factory: function AuthUtilBase_Factory() { return new AuthUtilBase(ɵɵinject(Platform), ɵɵinject(ApiService), ɵɵinject(CryptoService)); }, token: AuthUtilBase, providedIn: "root" });
AuthUtilBase = __decorate([
    Injectable({
        providedIn: 'root',
    }),
    __metadata("design:paramtypes", [Platform,
        ApiService,
        CryptoService])
], AuthUtilBase);

export { ApiService, AuthUtilBase, ConfigOauthService, CryptoService, DataDetailStorage, DataStorageExpired, DeviceInfoBase, ExtraAttribute, ExtraHeader, ResultStatusLiveness, ResultTransactionKey, StatusLivenessEnum, StorageKeys, StorageService, TransactionKeyEnum, UiBsOauthModule, UserProfileBase };
//# sourceMappingURL=wlp-ui-bs-oauth.js.map
